/**
 * KB-META
 * Purpose: Socket io token
 * Role: ui.module
 * EntryPoints: 
 * Inputs: 
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=tokens/socket-io.token; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { InjectionToken } from '@angular/core';

export const SOCKET_IO = new InjectionToken<any>('socket.io'); 